import { useFormContext } from 'react-hook-form';

import { FlexContainer } from 'features/common/components/FlexContainer';
import { InputProps } from './types';
import { useAppSelector } from 'store/hooks';
import { RootState } from 'store';

import { Label, StyledInput } from './Input.styles';

export const Input = ({ id, name, placeholder }: InputProps) => {
	const { register } = useFormContext();
	const { isPunchup } = useAppSelector(({ auth }: RootState) => auth);

	return (
		<FlexContainer flexDirection="column" gap="8px">
			<Label isPunchup={isPunchup}>{name}</Label>
			<StyledInput placeholder={placeholder} id={id} {...register(id)} />
		</FlexContainer>
	);
};
